module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "owl-carousel"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [(item.href) ? _c('div', [(item.text) ? _c('a', {
      staticClass: "sliderTitle",
      attrs: {
        "href": item.href
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()]) : _c('div', [(item.text) ? _c('p', {
      staticClass: "sliderTitle"
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()]), _vm._v(" "), (item.data) ? _c('p', {
      staticClass: "data"
    }, [_vm._v(_vm._s(item.data) + "\n            ")]) : _vm._e()])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7494466"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/slider-otherNews.vue
// module id = 267
// module chunks = 36